export const menuItems = [
  {
    name: "tentang",
    label: "Tentang",
  },
  {
    name: "blog",
    label: "Blog",
  },
  {
    name: "press",
    label: "Liputan Media",
  },
  {
    name: "kontak",
    label: "Kontak",
  },
];
